/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
window.defaultTimeZone = "Z-03:00";

const a00 = require("./public/template/pbds/loader.css");
const pb1000 = require("./public/template/cookie-consent.css");

const jqueryUi = require("webpack-jquery-ui");
const jquery = require("jquery");
const pbCore = require("./public/apis/pb2020.core");
const pbUtil = require("./public/apis/manager/util");
window.jSmart = require("jsmart/dist/jsmart");
window.GI = require("gi-jsonrpc");

const skeleton = require("jquery.skeleton.loader");
